import { Flex, Space, Title } from '@mantine/core';
import { useIntl } from 'react-intl';

import { useVerifyEmailForm } from '@/features/auth/view/email-verify-form/hooks/useVerifyEmailForm';
import { LBBackButton } from '@/shared/modules';
import { LBButton, LBTextField } from '@/shared/ui-kit/components';

export const VerifyEmailForm = () => {
  const {
    state: { form },
    functions: { abort, onSubmit }
  } = useVerifyEmailForm();

  const { formatMessage } = useIntl();

  return (
    <form onSubmit={onSubmit}>
      <Space h='24' />
      <LBBackButton />
      <Space h='24' />
      <Title order={1}>
        {formatMessage({ id: 'pages.auth.verifyEmail.title' })}
      </Title>

      <Space h='48' />
      <LBTextField
        key={form.key('email')}
        disabled={form.submitting}
        label={formatMessage({ id: 'form.email.label' })}
        placeholder={formatMessage({
          id: 'form.email.placeholder'
        })}
        {...form.getInputProps('email')}
      />
      <Space h='16' />
      <Space h='32' />
      <Flex direction='column'>
        <LBButton
          disabled={!form.isValid()}
          loading={form.submitting}
          type='submit'
        >
          {formatMessage({ id: 'form.buttons.continue' })}
        </LBButton>
        <Space h='8' />

        <LBButton variant='outline' onClick={abort}>
          {formatMessage({ id: 'form.buttons.cancel' })}
        </LBButton>
        <Space h='48' />
      </Flex>
    </form>
  );
};
